import {IndieIslandRoutes} from 'Shared/routes/IndieIslandRoutes';
import {Links} from 'Shared/config/Links';
import {Nav as IndieIslandNav} from 'Shared/config/IndieIslandNav';
import {IVenueConfig} from 'Shared/config/IVenueConfig';
import { IndieIslandTheme } from 'Shared/frontend/IndieIslandTheme';


export class IndieIslandConfig implements IVenueConfig
{
	theme() { return (new IndieIslandTheme()).settings(); } 

	links() { return Links; }

	nav() { return IndieIslandNav; }

	routes()
	{
		return (new IndieIslandRoutes()).routes();
	}
}
